
import { MapConfig } from 'lib-customizations/types'

const mapConfig: MapConfig = {
  center: [64.8373, 25.1864],
  initialZoom: 13,
  addressZoom: 14,
  searchAreaRect: {
    maxLatitude: 65.13735880808483,
    minLatitude: 64.43735880808483,
    maxLongitude: 25.386438236813885,
    minLongitude: 24.786438236813885,
  },
  careTypeFilters: ['DAYCARE', 'PRESCHOOL', 'CLUB'],
  unitProviderTypeFilters: [
    'MUNICIPAL',
    'PURCHASED',
    'PRIVATE',
    'PRIVATE_SERVICE_VOUCHER',
  ],
}
export default mapConfig
